export default __webpack_public_path__ + "static/media/ClassonBlack3.353e3e71.png";